import { render, staticRenderFns } from "./BatchMain.vue?vue&type=template&id=445a6588"
import script from "./BatchMain.vue?vue&type=script&lang=js"
export * from "./BatchMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports